export const CREATE_JOB_ASSIGNMENT = `
  mutation CreateJobAssignment($object: job_assignments_insert_input!) {
    insert_job_assignments_one(object: $object) {
      id
      job_id
      company_id
      technical_team_id
      technical_user_id
      financial_team_id
      financial_user_id
      assigned_by
      created_at
      company {
        id
        name
      }
      technical_team {
        id
        name
      }
      technical_user {
        id
        first_name
        last_name
      }
      financial_team {
        id
        name
      }
      financial_user {
        id
        first_name
        last_name
      }
      assigned_by_user {
        id
        first_name
        last_name
      }
      job {
        id
        job_title
        job_status
      }
    }
  }
`;

export const UPDATE_JOB_ASSIGNMENT = `
  mutation UpdateJobAssignment($id: Int!, $set: job_assignments_set_input!) {
    update_job_assignments_by_pk(pk_columns: {id: $id}, _set: $set) {
      id
      job_id
      company_id
      technical_team_id
      technical_user_id
      financial_team_id
      financial_user_id
      assigned_by
      created_at
      company {
        id
        name
      }
      technical_team {
        id
        name
      }
      technical_user {
        id
        first_name
        last_name
      }
      financial_team {
        id
        name
      }
      financial_user {
        id
        first_name
        last_name
      }
      assigned_by_user {
        id
        first_name
        last_name
      }
      job {
        id
        job_title
        job_status
      }
    }
  }
`;

export const DELETE_JOB_ASSIGNMENT = `
  mutation DeleteJobAssignment($id: Int!) {
    delete_job_assignments_by_pk(id: $id) {
      id
    }
  }
`;
